document.addEventListener(
    'DOMContentLoaded',
    () => {
        const card = document.querySelector(
            '[data-meetup-arrival]'
        );

        if (!card) {
            return;
        }

        const button = card.querySelector(
            '[data-arrival-button]'
        );

        const status = card.querySelector(
            '[data-arrival-status]'
        );

        const count = card.querySelector(
            '[data-arrival-count]'
        );

        if (
            !button
            || !status
            || !count
        ) {
            return;
        }

        const arriveUrl =
            card.dataset.arriveUrl;

        const departUrl =
            card.dataset.departUrl;

        if (
            !arriveUrl
            || !departUrl
        ) {
            return;
        }

        const csrfToken =
            document.querySelector(
                'meta[name="csrf-token"]'
            )?.content;

        let arrived =
            button.dataset.arrived
            === 'true';

        const updateInterface = (
            isArrived,
            arrivedCount
        ) => {
            arrived = isArrived;

            button.dataset.arrived =
                isArrived
                    ? 'true'
                    : 'false';

            button.textContent =
                isArrived
                    ? 'Leave Meetup'
                    : "I'm Here";

            status.innerHTML =
                isArrived
                    ? '<span class="inline-flex items-center gap-1.5"><span class="h-2.5 w-2.5 rounded-full bg-emerald-500" aria-hidden="true"></span> You\'re here!</span>'
                    : '<span class="inline-flex items-center gap-1.5"><svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M12 21s7-5.25 7-12a7 7 0 1 0-14 0c0 6.75 7 12 7 12Z"/><circle cx="12" cy="9" r="2.5"/></svg> You haven\'t checked in yet.</span>';

            count.textContent =
                `${arrivedCount} ${
                    arrivedCount === 1
                        ? 'member'
                        : 'members'
                } here now`;

            const currentMemberCard =
                document.querySelector(
                    '[data-current-member]'
                );

            const memberStatus =
                currentMemberCard
                    ?.querySelector(
                        '[data-member-arrival-status]'
                    );

            if (memberStatus) {
                memberStatus.innerHTML =
                    isArrived
                        ? '<span class="inline-flex items-center gap-1.5 font-bold text-emerald-400"><span class="h-2.5 w-2.5 rounded-full bg-emerald-500" aria-hidden="true"></span> Here now</span>'
                        : '<span class="inline-flex items-center gap-1.5 font-bold text-slate-500"><span class="h-2.5 w-2.5 rounded-full border border-zinc-400" aria-hidden="true"></span> Left meetup</span>';
            }
        };

        button.addEventListener(
            'click',
            async () => {
                button.disabled = true;

                const originalText =
                    button.textContent;

                button.textContent =
                    arrived
                        ? 'Leaving…'
                        : 'Checking in…';

                const url =
                    arrived
                        ? departUrl
                        : arriveUrl;

                try {
                    const response =
                        await fetch(
                            url,
                            {
                                method: 'PATCH',

                                credentials:
                                    'same-origin',

                                headers: {
                                    Accept:
                                        'application/json',

                                    'Content-Type':
                                        'application/json',

                                    'X-Requested-With':
                                        'XMLHttpRequest',

                                    ...(csrfToken
                                        ? {
                                            'X-CSRF-TOKEN':
                                            csrfToken,
                                        }
                                        : {}),
                                },

                                body:
                                    JSON.stringify({}),
                            }
                        );

                    const data =
                        await response.json()
                            .catch(
                                () => ({})
                            );

                    if (!response.ok) {
                        throw new Error(
                            data.message
                            ?? 'The meetup arrival status could not be updated.'
                        );
                    }

                    updateInterface(
                        Boolean(
                            data.arrived
                        ),
                        Number(
                            data.arrived_count
                            ?? 0
                        )
                    );
                } catch (error) {
                    status.textContent =
                        error instanceof Error
                            ? error.message
                            : 'The meetup arrival status could not be updated.';

                    button.textContent =
                        originalText;
                } finally {
                    button.disabled = false;
                }
            }
        );
    }
);